import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  API_INITIATE_GET_SCT_CUSTOMER_DATA,
  API_COMPLETE_GET_SCT_CUSTOMER_DATA,
  API_SCT_INITIATE_AUTO_SAVE,
  API_SCT_COMPLETE_AUTO_SAVE,
  COMPLETE_SCT_CALLBACK_REQUEST,
} from '../../app-constants';
import { submitSCTRequestCallback, submitSCTAutoSave } from './sct-homepage.actions';
import View from './sct-homepage.presenter';

// Reducer
export const sctHomePageReducer = (state = {
  loading: false,
  dataLoaded: false,
  formSubmitted: false,
  customerAccountName: '',
  customerContactPhone: '',
  sitesData: [],
  estimatedTotalSitesCosts: '',
  autoSaveStatus: 'No Changes Saved',
  alreadySubmitted: false,
  alreadySubmittedDate: '',
}, action) => {
  switch (action.type) {
    case API_INITIATE_GET_SCT_CUSTOMER_DATA:
      return { ...state, loading: true, dataLoaded: false, formSubmitted: false };
    case API_COMPLETE_GET_SCT_CUSTOMER_DATA: {
      return {
        ...state,
        loading: false,
        dataLoaded: true,
        customerAccountName: action.data.accountName,
        customerContactPhone: action.data.contactNumber,
        sitesData: action.data.sitesData,
        estimatedTotalSitesCosts: action.data.estimatedTotalSitesCosts,
        alreadySubmitted: action.data.alreadySubmitted,
        alreadySubmittedDate: action.data.submittedDate,

      };
    }
    case API_SCT_INITIATE_AUTO_SAVE: {
      return {
        ...state,
        autoSaveStatus: 'saving',
      };
    }
    case API_SCT_COMPLETE_AUTO_SAVE: {
      return {
        ...state,
        autoSaveStatus: 'saved',
      };
    }
    case COMPLETE_SCT_CALLBACK_REQUEST: {
      return {
        ...state,
        alreadySubmitted: true,
        alreadySubmittedDate: action.data.submittedDate,
      };
    }

    default:
      return state;
  }
};

// Map & Connect
export const mapStateToProps = state => ({
  customerAccountNumber: state.sctHomePageReducer.customerAccountNumber,
  authorableContent: state.authorableContentReducer.authorableContent,
  customerAccountName: state.sctHomePageReducer.customerAccountName,
  dataLoaded: state.sctHomePageReducer.dataLoaded,
  formSubmitted: state.sctHomePageReducer.formSubmitted,
  customerContactPhone: state.sctHomePageReducer.customerContactPhone,
  sitesData: state.sctHomePageReducer.sitesData,
  estimatedTotalSitesCosts: state.sctHomePageReducer.estimatedTotalSitesCosts,
  autoSaveStatus: state.sctHomePageReducer.autoSaveStatus,
  alreadySubmitted: state.sctHomePageReducer.alreadySubmitted,
  alreadySubmittedDate: state.sctHomePageReducer.alreadySubmittedDate,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    submitSCTRequestCallback,
    submitSCTAutoSave,
  }, dispatch),
});

const SCTHomePage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);


export default SCTHomePage;
